import { render, staticRenderFns } from "./inputArea.vue?vue&type=template&id=7cbe2b4e&scoped=true"
import script from "./inputArea.vue?vue&type=script&lang=js"
export * from "./inputArea.vue?vue&type=script&lang=js"
import style0 from "./inputArea.vue?vue&type=style&index=0&id=7cbe2b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbe2b4e",
  null
  
)

export default component.exports